import React from 'react';
import { connect } from 'react-redux';
import CountUp from 'react-countup';
import { setDialogs } from '../../../actions';
import { $http, openWebViewWithType } from '../../../lib/kbApp/kbJsBridgePromise';
import { reportUrl } from '../../../const/index';
import { detector } from '../../../lib/util/Detect';
import { setWelfareAnimation, setProperty } from '../../../rootStore';
import sendBoss from '../../../lib/base/sendBoss';
import './index.scss';
import '../../../common/css/animate-flowers.scss';

class SignInCoinDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFlowerAnim: true,
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
    const { welfare } = this.props;
    const coupons = welfare.coupons || [];
    const { showUrls = [] } = coupons[0] || {};
    try {
      showUrls.forEach((url) => {
        $http.get(url);
        sendBoss('element_exposure', {
          element_type: 'signInCoinDialog',
          element_name: 'coupon',
          extra_info: { showUrl: url },
        });
      });
    } catch (error) {
      console.log('exporse click url error', error);
      sendBoss('element_exposure', {
        element_type: 'signInCoinDialog',
        extra_info: { showUrlError: error },
      });
    }

    setTimeout(() => {
      this.setState({ showFlowerAnim: false });
    }, 1600);
  }

  close = () => {
    this.props.dialogs.pop();
    this.props.dispatch(setDialogs(this.props.dialogs));

    setWelfareAnimation();

    // 给资产加金币和现金
    const { value, welfareType } = this.props;
    setProperty({ value, welfareType });
  }

  contentRender = () => {
    const { welfare = {}, value, welfareType, kbApp = {} } = this.props;
    const coupons = welfare.coupons && welfare.coupons.length > 0 ? welfare.coupons : [{}];
    const { source, title, icon } = coupons[0];

    if (welfareType === 6) {  // 卡券奖励
      const userInfo = kbApp.userInfo || {};

      return (
        <React.Fragment>
          <div className="congra vip">恭喜获得腾讯视频会员VIP{value}天</div>
          <div className="prizeVip"></div>
          <div className="account">
            使用此账号
						<span className="avator"><img src={userInfo.avatar} /></span>
            <span className="nickname">{userInfo.nick || ''}</span>
          </div>
          <div className="tip">登录 [腾讯视频] 即可使用</div>
        </React.Fragment>
      );
    } if (welfareType === 0 || welfareType === 4) {  // 现金奖励
      const formateValue = `${value / 100}`.split('.');
      const decimals = formateValue.length > 1 ? formateValue[1].length : 0;
      return (
        <React.Fragment>
          <div className="congra">恭喜获得现金</div>
          <CountUp start={0} end={value / 100} delay={0} decimals={decimals}>
            {({ countUpRef }) => (
              <div className="num">
                <span ref={countUpRef} />
                <span className="yuan">元</span>
              </div>
            )}
          </CountUp>
        </React.Fragment>
      );
    } if (welfareType === 3 || welfareType === 5) {  // 金币奖励
      return (
        <React.Fragment>
          <div className="congra">恭喜获得金币</div>
          <CountUp start={0} end={value} delay={0}>
            {({ countUpRef }) => (
              <div className="num">
                <span className="plus"></span>
                <span ref={countUpRef} />
              </div>
            )}
          </CountUp>
        </React.Fragment>
      );
    } if (welfareType === 1 || welfareType === 2) {  // 礼券广告
      return (
        <React.Fragment>
          <div className="congra">恭喜获得一张礼券</div>
          <div className="coupon">
            <div className="info">
              <h4>{source}</h4>
              <div className="ticket-title">{title}</div>
            </div>
            <img src={icon} className="icon" />
          </div>
        </React.Fragment>
      );
    }
  }

  btnRender = () => {
    const { welfareType } = this.props;

    if (welfareType === 1 || welfareType === 2) {  // 礼券广告
      return (
        <div className="btn" onClick={() => this.couponClick()} log-click-eltype="confirm">立即查看</div>
      );
    }
    return (
      <div className="btn" onClick={this.close} log-click-eltype="confirm">继续赚钱</div>
    );
  }

  couponClick = () => {
    const { welfare } = this.props;
    const coupons = welfare.coupons || [];
    const { clickUrls = [], usepage = [], ticket = '' } = coupons[0] || {};
    sendBoss('element_click', {
      element_type: 'signInCoinDialog',
      element_name: 'coupon_detail_btn',
      extra_info: {
        coupons: coupons[0],
      },
    });
    try {
      if (detector.app.kuaibao) {
        $http.get(`${reportUrl}?ticket=${ticket}&action=click&actionTime=${new Date().getTime() * 1000}`);
      } else {
        clickUrls.forEach((url) => {
          $http.get(url);
        });
      }
    } catch (error) {
      console.log('exporse click url error', error);
    }

    this.close();
    if (detector.app.kuaibao) {
      openWebViewWithType(usepage);
    } else {
      window.location.href = usepage;
    }
  }

  render() {
    return (
      <div className="signInCoinDialog">
        <div className={`gka-flower-wrap ${this.state.showFlowerAnim ? 'flower-animation' : ''}`}></div>
        <div className="dialog">
          <div className="coinDialog">
            <div className="bag">
              <div className="bag-coin"></div>
            </div>
            <div className="board">
              <div className="status">{this.props.from === 'task' ? '领取成功' : '签到成功'}</div>
              {this.contentRender()}
              {this.btnRender()}
            </div>
          </div>
          <div className="close" onClick={this.close} log-click-eltype="close"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, kbApp, myIntegral } = state;
  return {
    dialogs,
    kbApp,
    myIntegral,
  };
};

export default connect(mapStateToProps)(SignInCoinDialog);
